import { render, staticRenderFns } from "./FornecedorUsuarios.vue?vue&type=template&id=3dfe1e6a"
import script from "./FornecedorUsuarios.vue?vue&type=script&lang=js"
export * from "./FornecedorUsuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports